import { axios } from './axios';

export const getReturnInfo = async ({ orderId }: { orderId: string }) => {
  return await axios.get(`/returns/order/${orderId}`);
};
